"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastProvider = void 0;
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _ToastContext = require("./ToastContext");
var _Toast = require("./Toast");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Create a random ID
function generateUEID() {
  let first = Math.random() * 46656 | 0;
  let second = Math.random() * 46656 | 0;
  first = ('000' + first.toString(36)).slice(-3);
  second = ('000' + second.toString(36)).slice(-3);
  return first + second;
}
const ToastProvider = props => {
  const [toasts, setToasts] = _react.default.useState([]);
  const [mounted, setMounted] = _react.default.useState(false);
  _react.default.useEffect(() => {
    setMounted(true);
  }, []);
  const success = _ref => {
    let {
      title,
      text
    } = _ref;
    setToasts(currentToasts => [...currentToasts, {
      id: generateUEID(),
      title,
      text,
      type: 'success'
    }]);
  };
  const warning = _ref2 => {
    let {
      title,
      text
    } = _ref2;
    setToasts(currentToasts => [...currentToasts, {
      id: generateUEID(),
      title,
      text,
      type: 'warning'
    }]);
  };
  const danger = _ref3 => {
    let {
      title,
      text
    } = _ref3;
    setToasts(currentToasts => [...currentToasts, {
      id: generateUEID(),
      title,
      text,
      type: 'danger'
    }]);
  };
  const _close = id => setToasts(currentToasts => currentToasts.filter(toast => toast.id !== id));
  const contextValue = _react.default.useMemo(() => ({
    success,
    warning,
    danger
  }), []);
  if (!mounted) return null;
  return /*#__PURE__*/_react.default.createElement(_ToastContext.ToastContext.Provider, {
    value: contextValue
  }, props.children, /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-toast-wrapper"
  }, toasts.map(toast => /*#__PURE__*/_react.default.createElement(_Toast.Toast, {
    key: toast.id,
    close: () => _close(toast.id),
    type: toast.type,
    title: toast.title,
    text: toast.text
  }))), document.body));
};
exports.ToastProvider = ToastProvider;